import type { FC } from 'react';

import type { IUploaderProps } from './IUploadResult';
import { UploaderForm } from './UploaderForm';

export const Uploader: FC<IUploaderProps> = (props) => <UploaderForm {...props} />;
